import { render } from "./LearningRecords.vue?vue&type=template&id=f2be7b9a&scoped=true"
import script from "./LearningRecords.vue?vue&type=script&lang=js"
export * from "./LearningRecords.vue?vue&type=script&lang=js"

import "./LearningRecords.css?vue&type=style&index=0&id=f2be7b9a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2be7b9a"]])

export default __exports__